import { Dimensions } from "react-native";
import * as Device from "expo-device";

const TOAST = {
  TOAST_LENGTH_SHORT: 3000,
};
const ONE_SEC = 1000;

const SCREEN_WIDTH = Dimensions.get("screen").width;
const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH_WINDOW = Dimensions.get("window").width;
const SCREEN_HEIGHT_WINDOW = Dimensions.get("window").height;
const DEBOUNCE_CALL = 600;

enum LANGUAGE {
  ENGLISH = "en",
  MALAYALAM = "ml",
}

enum ADDRESS_TYPE {
  HOME = "Home",
  OFFICE = "Office",
}

enum GENDER {
  MALE = "male",
  FEMALE = "female",
  OTHER = "other",
}

const DATE_FORMAT = "YYYY-MM-DD";
const DATE_FORMAT_SELECTED = "YYYY/MM/DD";
const READABLE_DATE_FORMAT = "DD, MMM YYYY";
const READABLE_DATE__TIME_FORMAT = "DD, MMM YYYY hh:mm:ss a";

const CURRENCY = "INR";
const GUEST_ROLE = 0;
const TOP_STORE_RATING = 4;
const POPULAR_ITEMS_RATING = 4;

export {
  TOAST,
  ONE_SEC,
  SCREEN_WIDTH,
  SCREEN_WIDTH_WINDOW,
  SCREEN_HEIGHT_WINDOW,
  DEBOUNCE_CALL,
  LANGUAGE,
  ADDRESS_TYPE,
  DATE_FORMAT,
  READABLE_DATE_FORMAT,
  DATE_FORMAT_SELECTED,
  SCREEN_HEIGHT,
  GENDER,
  CURRENCY,
  GUEST_ROLE,
  TOP_STORE_RATING,
  POPULAR_ITEMS_RATING,
  READABLE_DATE__TIME_FORMAT
};

const TABLET_PC = Device.deviceType !== Device.DeviceType.PHONE;
const IS_TABLET = Device.deviceType === Device.DeviceType.TABLET;
const OTP_LENGTH = 6;
const OTP_TIMER = 30;

const PRV_KEY = "aB3!kL9%pZqW5xY8cV1";

export { TABLET_PC, OTP_LENGTH, OTP_TIMER, PRV_KEY, IS_TABLET };
